/**
 * Globaler Host für Export-PDF-Vorschau – überlebt Schliessen von Dropdown-Menüs.
 */
import React, { useLayoutEffect, useState } from "react";
import FilePreviewModal from "../components/ui/FilePreviewModal.jsx";
import { sanitizeFileUrl } from "./filePreview.js";

const CLOSED = Object.freeze({
  open: false,
  pdfUrl: "",
  title: "PDF",
  fileName: "export.pdf",
  description: "",
  previewModule: "",
  fileId: null,
});

/** @type {null | ((patch: object) => void)} */
let dispatchOpen = null;
/** @type {null | { pdfUrl: string, title?: string, fileName?: string, description?: string }} */
let pendingOpen = null;

function applyOpen(patch) {
  if (!dispatchOpen) {
    pendingOpen = patch;
    return false;
  }
  dispatchOpen({ ...CLOSED, ...patch, open: true });
  pendingOpen = null;
  return true;
}

export function PdfExportPreviewModal({
  open,
  onClose,
  pdfUrl,
  title = "PDF",
  fileName = "export.pdf",
  description = "",
  previewModule = "",
  fileId = null,
}) {
  const safeUrl = sanitizeFileUrl(pdfUrl);
  const canOpen = Boolean(safeUrl || (previewModule && fileId));
  return (
    <FilePreviewModal
      open={Boolean(open && canOpen)}
      onClose={onClose}
      fileUrl={safeUrl}
      fileName={fileName || "export.pdf"}
      fileType="pdf"
      title={title || "PDF"}
      description={description || ""}
      previewModule={previewModule}
      fileId={fileId}
      canDownload
      canOpenInNewTab
    />
  );
}

/**
 * @param {{ pdfUrl: string, title?: string, fileName?: string, description?: string }} opts
 * @returns {boolean}
 */
export function openPdfExportPreview(opts = {}) {
  const patch = {
    pdfUrl: opts.pdfUrl || "",
    title: opts.title || "PDF",
    fileName: opts.fileName || "export.pdf",
    description: opts.description || "",
    previewModule: opts.previewModule || "",
    fileId: opts.fileId ?? null,
  };
  const hasUrl = Boolean(sanitizeFileUrl(patch.pdfUrl));
  const hasMeta = Boolean(
    String(patch.previewModule || "").trim() && Number(patch.fileId) > 0,
  );
  if (!hasUrl && !hasMeta) return false;
  return applyOpen(patch);
}

export function PdfExportPreviewHost() {
  const [state, setState] = useState(CLOSED);

  useLayoutEffect(() => {
    dispatchOpen = (patch) => setState((prev) => ({ ...prev, ...patch }));
    if (pendingOpen) {
      setState({ ...CLOSED, ...pendingOpen, open: true });
      pendingOpen = null;
    }
    return () => {
      dispatchOpen = null;
    };
  }, []);

  return (
    <PdfExportPreviewModal
      open={state.open}
      onClose={() => setState(CLOSED)}
      pdfUrl={state.pdfUrl}
      title={state.title}
      fileName={state.fileName}
      description={state.description}
      previewModule={state.previewModule}
      fileId={state.fileId}
    />
  );
}
